// Bilingual sector (market segment) catalogue
export const SECTORS = [
  {
    slug: "particuliers-residences",
    icon: "Home",
    fr: {
      title: "Particuliers & résidences",
      short: "Internet fiable pour les maisons, appartements, complexes résidentiels, lotissements et immeubles collectifs.",
      body: "Nous connectons les foyers avec la technologie la plus adaptée à leur quartier : fibre lorsqu'elle est disponible, Internet fixe sans fil pour un déploiement rapide, et solutions adaptées aux immeubles collectifs et lotissements.",
      points: ["Fibre FTTH et FTTB pour les résidences", "Internet fixe sans fil pour les zones en cours de fibrage", "Offres pensées pour un usage familial réel", "Installation et accompagnement par des équipes locales"],
    },
    en: {
      title: "Households & residences",
      short: "Reliable Internet for houses, apartments, residential complexes, housing estates and multi-dwelling buildings.",
      body: "We connect households with the technology best suited to their neighbourhood: fibre where available, fixed wireless for rapid deployment, and tailored solutions for multi-dwelling buildings and estates.",
      points: ["FTTH and FTTB fibre for residences", "Fixed wireless for areas still being fibred", "Plans designed for real family usage", "Installation and support by local teams"],
    },
  },
  {
    slug: "entreprises",
    icon: "Building2",
    fr: {
      title: "Entreprises",
      short: "Connectivité dédiée, réseaux sécurisés et services administrés pour les PME, grandes entreprises, banques, industries et groupes multisites.",
      body: "De la PME au groupe multisite, nous concevons des architectures qui allient performance, sécurité et continuité d'activité : accès dédiés, SD-WAN, MPLS, sécurité et services administrés.",
      points: ["Accès Internet dédiés et évolutifs", "Interconnexion multi-sites (SD-WAN, MPLS, VPN)", "Sécurité réseau et vidéosurveillance", "SLA pouvant atteindre 99,9 % selon l'offre, l'architecture et les conditions contractuelles"],
    },
    en: {
      title: "Businesses",
      short: "Dedicated connectivity, secure networks and managed services for SMEs, large enterprises, banks, industries and multi-site groups.",
      body: "From SMEs to multi-site groups, we design architectures combining performance, security and business continuity: dedicated access, SD-WAN, MPLS, security and managed services.",
      points: ["Dedicated, scalable Internet access", "Multi-site interconnection (SD-WAN, MPLS, VPN)", "Network security and video surveillance", "SLA of up to 99.9% depending on the offer, architecture and contractual conditions"],
    },
  },
  {
    slug: "operateurs-fai",
    icon: "Tower",
    fr: {
      title: "Opérateurs & FAI",
      short: "IP Transit, DIA, capacité de gros, interconnexion, échange de trafic et infrastructures permettant aux opérateurs d'accroître leur portée.",
      body: "Nous fournissons aux opérateurs et fournisseurs d'accès la capacité et l'infrastructure nécessaires à leur croissance : IP Transit, wholesale, peering et génie civil fibre.",
      points: ["IP Transit et DIA évolutifs", "Capacité de gros jusqu'à 100 Gbps selon conception et contrat", "Peering et échange de trafic", "Génie civil et dorsales fibre"],
    },
    en: {
      title: "Operators & ISPs",
      short: "IP Transit, DIA, wholesale capacity, interconnection, traffic exchange and infrastructure enabling operators to extend their reach.",
      body: "We provide operators and ISPs with the capacity and infrastructure needed for growth: IP Transit, wholesale, peering and fibre civil engineering.",
      points: ["Scalable IP Transit and DIA", "Wholesale capacity up to 100 Gbps subject to design and contract", "Peering and traffic exchange", "Civil engineering and fibre backbones"],
    },
  },
  {
    slug: "gouvernement",
    icon: "Landmark",
    fr: {
      title: "Gouvernement & secteur public",
      short: "Solutions de connectivité, réseaux privés, vidéosurveillance et infrastructures numériques pour les ministères, provinces, administrations et établissements publics.",
      body: "Nous accompagnons les institutions publiques dans la modernisation de leurs infrastructures : connectivité des administrations, réseaux privés sécurisés, vidéosurveillance et connectivité des territoires.",
      points: ["Connectivité des administrations et provinces", "Réseaux privés sécurisés", "Vidéosurveillance des espaces publics", "Connectivité rurale et territoriale"],
    },
    en: {
      title: "Government & public sector",
      short: "Connectivity solutions, private networks, video surveillance and digital infrastructure for ministries, provinces, administrations and public establishments.",
      body: "We support public institutions in modernising their infrastructure: government connectivity, secure private networks, video surveillance and territorial connectivity.",
      points: ["Connectivity for administrations and provinces", "Secure private networks", "Public-space video surveillance", "Rural and territorial connectivity"],
    },
  },
  {
    slug: "promoteurs-immobiliers",
    icon: "Building",
    fr: {
      title: "Promoteurs immobiliers",
      short: "Conception et déploiement de réseaux fibre-ready pour immeubles, quartiers, centres commerciaux et projets immobiliers.",
      body: "Nous concevons avec les promoteurs des infrastructures fibre-ready dès la conception des projets : génie civil, câblage d'immeubles, raccordement des résidents et valorisation des biens.",
      points: ["Conception fibre-ready dès la phase projet", "Génie civil et câblage d'immeubles", "Raccordement des résidents et commerces", "Valorisation des biens immobiliers"],
    },
    en: {
      title: "Property developers",
      short: "Design and deployment of fibre-ready networks for buildings, districts, shopping centres and property developments.",
      body: "We work with developers to design fibre-ready infrastructure from the project phase: civil engineering, building cabling, resident connections and property value enhancement.",
      points: ["Fibre-ready design from the project phase", "Civil engineering and building cabling", "Connection of residents and shops", "Enhanced property value"],
    },
  },
  {
    slug: "revendeurs",
    icon: "Store",
    fr: {
      title: "Revendeurs & agents",
      short: "Un programme de distribution permettant à des partenaires locaux de commercialiser les services Bula Telecoms et d'étendre notre présence.",
      body: "Notre programme de distribution permet à des partenaires locaux de commercialiser nos services et d'étendre la connectivité dans leurs zones, avec l'appui de nos équipes.",
      points: ["Programme de distribution structuré", "Accompagnement commercial et technique", "Extension de la couverture locale", "Relation de long terme"],
    },
    en: {
      title: "Resellers & agents",
      short: "A distribution programme enabling local partners to market Bula Telecoms services and extend our presence.",
      body: "Our distribution programme enables local partners to market our services and extend connectivity in their areas, backed by our teams.",
      points: ["A structured distribution programme", "Commercial and technical support", "Local coverage extension", "A long-term relationship"],
    },
  },
];

export const sectorBySlug = (slug) => SECTORS.find((s) => s.slug === slug);
